export default "__VITE_ASSET__BHW_y1zj__"